import { Instagram, Facebook, Mail, MessageCircle } from "lucide-react";
import {
  EMAIL,
  INSTAGRAM,
  FACEBOOK,
  WHATSAPP,
  TELEFONO_VISIBLE,
  gmailComposeUrl,
} from "@/lib/contacto";
import { track } from "@/lib/analytics";
import { ResponsiveImage } from "./ResponsiveImage";
import { abrirPreferencias } from "@/lib/consent";
const logo = { url: "/img/logotipo-pyme-visible-horizontal.png" };

export function Footer() {
  return (
    <footer className="pv-footer border-t border-ink/10">
      <div className="mx-auto grid max-w-[1320px] grid-cols-2 gap-6 px-5 py-8 sm:grid-cols-2 sm:gap-10 sm:px-6 sm:py-14 lg:grid-cols-[1.2fr_.8fr_1.15fr_1.15fr_.8fr] lg:gap-12 lg:px-10">
        <div className="col-span-2 sm:col-span-1">
          <ResponsiveImage
            sizes="(max-width: 639px) 168px, 240px"
            src={logo.url}
            width={2172}
            height={724}
            loading="lazy"
            alt="Logotipo de Pyme Visible"
            className="h-14 w-auto sm:h-20"
          />
          <p className="mt-2 max-w-xs text-sm text-muted-foreground sm:mt-4">
            Productos NFC + QR configurados para negocios de todo Chile.
          </p>
        </div>

        <nav className="grid content-start gap-3 text-sm">
          <span className="font-display font-bold text-navy">Navegación</span>
          <a className="text-muted-foreground hover:text-navy" href="/#inicio">
            Inicio
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/productos">
            Productos
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/stand-nfc-qr">
            Stand NFC + QR
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/tarjeta-nfc-qr">
            Tarjeta NFC
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/llavero-nfc-qr">
            Llavero NFC
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/stand-personalizado-nfc-qr">
            Stand personalizado NFC
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/casos">
            Casos reales
          </a>
          <a
            className="text-muted-foreground hover:text-navy"
            href="/videos/stand-nfc-resenas-google"
          >
            Demostración en video
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/#trabajos">
            Trabajos
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/#proceso">
            Cómo funciona
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/#contacto">
            Contacto
          </a>
        </nav>

        <nav className="grid content-start gap-3 text-sm">
          <span className="font-display font-bold text-navy">Legal</span>
          <a className="text-muted-foreground hover:text-navy" href="/privacidad">
            Política de privacidad
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/cookies">
            Política de cookies
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/terminos">
            Términos y condiciones
          </a>
          <a className="text-muted-foreground hover:text-navy" href="/reembolsos">
            Cancelaciones y reembolsos
          </a>
          <button
            type="button"
            onClick={abrirPreferencias}
            className="justify-self-start text-left text-muted-foreground underline hover:text-navy focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Preferencias de privacidad
          </button>
        </nav>

        <div className="grid content-start gap-3 text-sm">
          <span className="font-display font-bold text-navy">Contacto</span>
          <a
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-navy"
            href={gmailComposeUrl()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("email_click", { ubicacion: "footer" })}
          >
            <Mail className="h-4 w-4" /> {EMAIL}
          </a>
          <a
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-navy"
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { ubicacion: "footer" })}
          >
            <MessageCircle className="h-4 w-4" aria-hidden="true" /> WhatsApp {TELEFONO_VISIBLE}
          </a>
          <span className="text-muted-foreground">Chile</span>
        </div>

        <div className="grid content-start gap-3 text-sm">
          <span className="font-display font-bold text-navy">Redes</span>
          <div className="flex gap-3">
            <a
              href={INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram de Pyme Visible"
              onClick={() => track("social_click", { red: "instagram", ubicacion: "footer" })}
              className="pv-icon-button grid h-11 w-11 place-items-center rounded-full text-muted-foreground transition-colors hover:border-primary hover:text-navy"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook de Pyme Visible"
              onClick={() => track("social_click", { red: "facebook", ubicacion: "footer" })}
              className="pv-icon-button grid h-11 w-11 place-items-center rounded-full text-muted-foreground transition-colors hover:border-primary hover:text-navy"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp de Pyme Visible"
              onClick={() => track("whatsapp_click", { ubicacion: "footer_redes" })}
              className="pv-icon-button grid h-11 w-11 place-items-center rounded-full text-muted-foreground transition-colors hover:border-primary hover:text-navy"
            >
              <MessageCircle className="h-4 w-4" />
            </a>
          </div>
          <span className="text-xs text-muted-foreground">
            Síguenos y conversemos por WhatsApp.
          </span>
        </div>
      </div>

      <div className="border-t border-border px-5 py-4 text-center text-xs text-muted-foreground sm:px-6 sm:py-6">
        <p>© {new Date().getFullYear()} Pyme Visible · Chile</p>
        <p className="mx-auto mt-2 hidden max-w-3xl sm:block">
          Las fotografías y materiales visuales son de titularidad del responsable, creados con
          herramientas de inteligencia artificial o de bancos de imágenes con licencia. Las reseñas
          corresponden a experiencias reales de clientes.
        </p>
      </div>
    </footer>
  );
}
